// Common
export const xVwapLabel = 'xVWAP';
export const vwapLabel = 'VWAP';

// Expected vs Actual
export const actualVolumeLabel = 'Act Vol';
export const expectedVolumeLabel = 'Exp Vol';

// Order Fills
export const avgExecLabel = 'Avg Exec';
export const fillPriceLabel = 'Fill Price';
export const fillVolumeLabel = 'Fill Volume';
export const percentDeltaLabel = '% Cmp';
export const priceLabel = 'Price';

// Percentage of Market Volume
export const avgParticipationLabel = 'Avg Participation';
export const binParticipationLabel = 'Bin Participation';

// Performance vs Index
export const getPerfVsIndexLabel = (relativePerformanceIndex: string) =>
    `Perf vs. ${relativePerformanceIndex}`;
